import React, { useEffect, Fragment, useState } from 'react'
import { Container, Card, Row, Col, Button, Form } from 'react-bootstrap'
import BootstrapTable from 'react-bootstrap-table-next'
import paginationFactory from 'react-bootstrap-table2-paginator'
import ToolkitProvider from 'react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min'
import { LoadingComponent } from 'recupero-comunes'
import { useDispatch, useSelector } from 'react-redux'
import { Modal } from 'react-bootstrap'
import { useFormik } from 'formik'
import * as Yup from 'yup'
import { consultarInfoErroresCargaAnalytic } from '../../store/actions/carga-casos-analytic-action'
import { getInfoCargaAnalyticPrevio } from '../../store/actions/carga-casos-analytic-action'

const DetalleCasos = ({ data }) => {
  const [showAsignar, setShowAsignar] = useState(false)
  const [showErrores, setShowErrores] = useState(false)
  const [tituloModal, setTituloModal] = useState("")  
  const dispatch = useDispatch() 

  const handleShowAsignar = () => setShowAsignar(true)
  const handleCloseAsignar = (op) => {
    if (op===1) {
      if (!formik.errors.casosPagados && !formik.errors.casosAsignados) {
        setShowAsignar(false)
      }      
    }else{
      setShowAsignar(false)
      handleReset()
    }
  }

  const handleShowErrores = () => setShowErrores(true)
  const handleCloseErrores = () => {
    setShowErrores(false)
  }

  const loading = useSelector(
    (state) => state.consultarCasosAnalyticReducer.loading
  )

  const dataErrores = useSelector((state) => state.cargaCasosAnalyticReducer.infoErroresCargaAnalytic)

  const buscarErrores = async (row) => {

    if (!row.caa_int_id) {
      console.log("Error: 'caa_int_id' no está definido en 'row'")
      return
    }

    setTituloModal(
      "Errores Archivo ID: " + row.caa_int_id + " - Nombre: " + row.caa_var_nombreArchivo + " - Fecha Carga: " + formatearFecha(row.caa_dat_fechaCarga)
    );

    let query = Buffer.from(
      JSON.stringify({
        cae_int_id: row.caa_int_id
      })
    ).toString('base64')

    await dispatch(consultarInfoErroresCargaAnalytic(query))    
    .then(() => {
        handleShowErrores();        
      })
      .catch((error) => {
        console.error('fallo la carga ', error.message)
      })
  }

  const formatearFecha = (fecha) => {
    if (!fecha) return ''
    return new Date(fecha).toLocaleDateString('es-CL', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric'
    })
  }

  const formik = useFormik({
    initialValues: {
      casosPagados: '',
      casosAsignados: ''
    },

    validationSchema: Yup.object({
      casosPagados: Yup.string().required(
        'El período de casos pagados es obligatorio'
      ),
      casosAsignados: Yup.string().required(
        'El período de casos asignados es obligatorio'
      )
    }),
    onSubmit: (values) => {      
      handleCloseAsignar(1)
      handleReset()
      console.log('periodos casos pagados ', values.casosPagados)
      console.log('periodos casos asignados ', values.casosAsignados)
    }
  })

  const handleReset = () => {    
    formik.resetForm()
  }

  const obtenerColumnas = () => [
    {
      dataField: 'caa_int_id',
      text: 'ID',
      sort: true,
      headerAlign: 'center',
      align: 'center',
      headerFormatter: (column, colIndex, { sortElement }) => (
        <div>
          {column.text}
          <br />
          {sortElement}
        </div>
      ),
      headerStyle: { color: 'white', backgroundColor: '#7594C1' }
    },
    {
      dataField: 'caa_dat_fechaCarga',
      text: 'Fecha Carga',
      formatter: (cell) => formatearFecha(cell),
      sort: true,
      headerAlign: 'center',
      align: 'center',
      headerFormatter: (column, colIndex, { sortElement }) => (
        <div>
          {column.text}
          <br />
          {sortElement}
        </div>
      ),
      headerStyle: { color: 'white', backgroundColor: '#7594C1' }
    },
    {
      dataField: 'caa_var_nombreArchivo',
      text: 'Archivo',
      sort: true,
      headerAlign: 'center',
      align: 'center',
      headerFormatter: (column, colIndex, { sortElement }) => (
        <div>
          {column.text}
          <br />
          {sortElement}
        </div>
      ),
      headerStyle: { color: 'white', backgroundColor: '#7594C1' }
    },
    {
      dataField: 'caa_int_casosActualizados',
      text: 'Casos Actualizados',
      sort: true,
      headerAlign: 'center',
      align: 'center',
      formatter: (cell) => cell ?? 0,
      headerFormatter: (column, colIndex, { sortElement }) => (
        <div>
          {column.text}
          <br />
          {sortElement}
        </div>
      ),
      headerStyle: { color: 'white', backgroundColor: '#7594C1' }
    },
    {
      dataField: 'caa_int_casosRechazados',
      text: 'Casos Rechazados',
      sort: true,
      headerAlign: 'center',
      align: 'center',
      formatter: (cell) => cell ?? 0,
      headerFormatter: (column, colIndex, { sortElement }) => (
        <div>
          {column.text}
          <br />
          {sortElement}
        </div>
      ),
      headerStyle: { color: 'white', backgroundColor: '#7594C1' }
    },
    {
      dataField: 'caa_int_resAsigInternos',
      text: 'Asignados Internos',
      sort: true,
      headerAlign: 'center',
      align: 'center',
      formatter: (cell) => cell ?? 0,
      headerFormatter: (column, colIndex, { sortElement }) => (
        <div>
          {column.text}
          <br />
          {sortElement}
        </div>
      ),
      headerStyle: { color: 'white', backgroundColor: '#7594C1' }
    },
    {
      dataField: 'caa_int_resAsigExternos',
      text: 'Asignados Externos',
      sort: true,
      headerAlign: 'center',
      align: 'center',
      formatter: (cell) => cell ?? 0,
      headerFormatter: (column, colIndex, { sortElement }) => (
        <div>
          {column.text}
          <br />
          {sortElement}
        </div>
      ),
      headerStyle: { color: 'white', backgroundColor: '#7594C1' }
    },
    {
      dataField: 'glosaEstado',
      text: 'Estado',
      sort: true,
      headerAlign: 'center',
      align: 'center',
      headerFormatter: (column, colIndex, { sortElement }) => (
        <div>
          {column.text}
          <br />
          {sortElement}
        </div>
      ),
      headerStyle: { color: 'white', backgroundColor: '#7594C1' }
    },
    {
      dataField: 'nombre',
      text: 'Usuario',
      sort: true,
      headerAlign: 'center',
      align: 'center',
      headerFormatter: (column, colIndex, { sortElement }) => (
        <div>
          {column.text}
          <br />
          {sortElement}
        </div>
      ),
      headerStyle: { color: 'white', backgroundColor: '#7594C1' }
    },
    {
      dataField: 'accion',
      text: 'Acción',
      isDummyField: true,
      formatter: (_, row) => (
        <div>
          <Button
            variant='outline-secondary me-md-2'
            size='sm'
            onClick={() => handleShowAsignar()}
          >
            <svg
              xmlns='http://www.w3.org/2000/svg'
              width='16'
              height='16'
              fill='currentColor'
              className='bi bi-gear-fill'
              viewBox='0 0 16 16'
            >
              <path d='M9.405 1.05c-.413-1.4-2.397-1.4-2.81 0l-.1.34a1.464 1.464 0 0 1-2.105.872l-.31-.17c-1.283-.698-2.686.705-1.987 1.987l.169.311c.446.82.023 1.841-.872 2.105l-.34.1c-1.4.413-1.4 2.397 0 2.81l.34.1a1.464 1.464 0 0 1 .872 2.105l-.17.31c-.698 1.283.705 2.686 1.987 1.987l.311-.169a1.464 1.464 0 0 1 2.105.872l.1.34c.413 1.4 2.397 1.4 2.81 0l.1-.34a1.464 1.464 0 0 1 2.105-.872l.31.17c1.283.698 2.686-.705 1.987-1.987l-.169-.311a1.464 1.464 0 0 1 .872-2.105l.34-.1c1.4-.413 1.4-2.397 0-2.81l-.34-.1a1.464 1.464 0 0 1-.872-2.105l.17-.31c.698-1.283-.705-2.686-1.987-1.987l-.311.169a1.464 1.464 0 0 1-2.105-.872l-.1-.34zM8 10.93a2.929 2.929 0 1 1 0-5.86 2.929 2.929 0 0 1 0 5.858z' />
            </svg>
          </Button>
          <br/>          
          <Button            
            variant='subir me-md-2 mt-2'
            size='sm'
            onClick={() => buscarErrores(row)}
            style={{height:"31px"}}
          >
            <svg
              xmlns='http://www.w3.org/2000/svg'
              width='16'
              height='16'
              fill='currentColor'
              className='bi bi-search'
              viewBox='0 0 16 16'
            >
              <path d='M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z' />
            </svg>
          </Button>
        </div>
      ),
      headerAlign: 'center',
      align: 'center',
      headerFormatter: (column, colIndex, { sortElement }) => (
        <div>
          {column.text}
          <br />
          {sortElement}
        </div>
      ),
      headerStyle: { color: 'white', backgroundColor: '#7594C1' }
    }
  ]

  const obtenerColumnasErrores = () => [
    // {
    //   dataField: 'cae_int_fila',
    //   text: 'Fila',
    //   sort: true,
    //   headerAlign: 'center',
    //   align: 'center',
    //   headerFormatter: (column, colIndex, { sortElement }) => (
    //     <div>
    //       {column.text}
    //       <br />
    //       {sortElement}
    //     </div>
    //   ),
    //   headerStyle: { color: 'white', backgroundColor: '#7594C1' }
    // },
    {
      dataField: 'cae_var_siniestro',
      text: 'Siniestro',
      sort: true,
      headerAlign: 'center',
      align: 'center',
      headerFormatter: (column, colIndex, { sortElement }) => (
        <div>
          {column.text}
          <br />
          {sortElement}
        </div>
      ),
      headerStyle: { color: 'white', backgroundColor: '#7594C1' }
    },
    // {
    //   dataField: 'cae_var_columna',
    //   text: 'Columna',
    //   sort: true,
    //   headerAlign: 'center',
    //   align: 'center',
    //   headerFormatter: (column, colIndex, { sortElement }) => (
    //     <div>
    //       {column.text}
    //       <br />
    //       {sortElement}
    //     </div>
    //   ),
    //   headerStyle: { color: 'white', backgroundColor: '#7594C1' }
    // },
    // {
    //   dataField: 'cae_var_valorColumna',
    //   text: 'Valor',
    //   sort: true,
    //   headerAlign: 'center',
    //   align: 'center',
    //   headerFormatter: (column, colIndex, { sortElement }) => (
    //     <div>
    //       {column.text}
    //       <br />
    //       {sortElement}
    //     </div>
    //   ),
    //   headerStyle: { color: 'white', backgroundColor: '#7594C1' }
    // },
    {
      dataField: 'cae_var_msgError',
      text: 'Mensaje de Error',
      sort: true,
      headerAlign: 'center',
      align: 'center',
      headerFormatter: (column, colIndex, { sortElement }) => (
        <div>
          {column.text}
          <br />
          {sortElement}
        </div>
      ),
      headerStyle: { color: 'white', backgroundColor: '#7594C1' }
    }
  ]

  const handleActualizarTabla = async () => {    
    try {
      const updatedData = await dispatch(getInfoCargaAnalyticPrevio()); 
    } catch (error) {
      console.error('Error al actualizar la tabla:', error);
    } 
  };

  const paginationOptions = {
    paginationSize: 5,
    showTotal: true,
    paginationTotalRenderer: (from, to, size) => (
      <span className='ms-2'>
        Mostrando {from} a {to} de {size} resultados
      </span>
    ),
    paginationWrapperClasses: 'custom-pagination-wrapper'
  }

  return (
    <Fragment>
      <Modal show={showErrores} onHide={handleCloseErrores} backdrop='static' size="lg">
        <Modal.Header closeButton>
          <Modal.Title>{tituloModal}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {dataErrores && dataErrores.length > 0 ? (
            <BootstrapTable
              keyField='cae_var_siniestro' 
              data={dataErrores} 
              columns={obtenerColumnasErrores()} 
              bootstrap4
              pagination={paginationFactory({
                paginationSize: 5,
                showTotal: true,
                paginationTotalRenderer: (from, to, size) => (
                  <span className='ms-2'>
                    Mostrando {from} a {to} de {size} resultados
                  </span>
                ),
                paginationWrapperClasses: 'custom-pagination-wrapper'
              })}
              noDataIndication={
                <div className='text-center'>No hay errores registrados</div>
              }
              headerWrapperClasses='table-secondary'
            />
          ) : (
            <div className='text-center'>Cargando errores...</div>
          )}
        </Modal.Body>
        <Modal.Footer>
          {/* <Button variant='primary' onClick={handleCloseErrores}>
            Aceptar
          </Button> */}
        </Modal.Footer>
      </Modal>
      <Modal show={showAsignar} onHide={handleCloseAsignar} backdrop='static'>
        <Modal.Header closeButton>
          <Modal.Title>Periodo Notificación</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={formik.handleSubmit}>
            <div>
              <Form.Group controlId='casosPagados' className='mb-3'>
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between'
                  }}
                >
                  <span>Casos Pagados:</span>
                  <Form.Control
                    type='month'
                    name='casosPagados'
                    value={formik.values.casosPagados}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    isInvalid={
                      formik.touched.casosPagados &&
                      !!formik.errors.casosPagados
                    }
                    lang='es-CL'
                    style={{ width: 'auto', marginLeft: '10px' }}
                  />
                </div>
              </Form.Group>
              <Form.Control.Feedback type='invalid'>
                {formik.errors.casosPagados}
              </Form.Control.Feedback>
              <Form.Group controlId='casosAsignados'>
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between'
                  }}
                >
                  <span>Casos Asignados:</span>
                  <Form.Control
                    type='month'
                    name='casosAsignados'
                    value={formik.values.casosAsignados}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    isInvalid={
                      formik.touched.casosAsignados &&
                      !!formik.errors.casosAsignados
                    }
                    lang='es-CL'
                    style={{ width: 'auto', marginLeft: '10px' }}
                  />
                </div>
                <Form.Control.Feedback type='invalid'>
                  {formik.errors.casosAsignados}
                </Form.Control.Feedback>
              </Form.Group>
            </div>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant='primary'
            onClick={(e) => {
              e.preventDefault()
              formik.handleSubmit()
            }}
          >
            Aceptar
          </Button>
        </Modal.Footer>
      </Modal>

      <style type='text/css'>
        {`
          .tabla-personalizada .react-bootstrap-table-pagination {
            margin-right: 0 !important;
            margin-left: 0 !important;
            margin-bottom: calc(var(--bs-gutter-x)* .5);
          }  
          
          .btn-subir {
            background-color: #00aeab;
            color: #FFFFFF;   
            height:40px;

          }
          .btn-subir:hover{
              background-color:#01cec8;
              color: #FFFFFF;              
          } 
        `}
      </style>
      <LoadingComponent show={loading} />
      <Container className='mt-4'>
        <Card>
          <Card.Header
            className='text-center'
            style={{ backgroundColor: '#4F517A', color: 'white' }}
          >
            Actualización Procesos Analytic Anteriores
          </Card.Header>
          <ToolkitProvider
            keyField='caa_int_id'
            data={data}
            columns={obtenerColumnas()}
            search
            bootstrap4
            defaultSorted={[{ dataField: 'caa_int_id', order: 'asc' }]}
          >
            {(props) => (
              <div>
                <Row className='mb-2'>
                  <Col className='d-grid gap-2 d-md-flex justify-content-md-end mt-2'>
                    <Form.Control
                      placeholder='Buscar en la grilla'
                      className='w-25'
                      onChange={(e) =>
                        props.searchProps.onSearch(e.target.value)
                      }
                    />
                    <Button variant='outline-info me-2' size='sm' onClick={handleActualizarTabla}>
                      <svg
                        xmlns='http://www.w3.org/2000/svg'
                        width='16'
                        height='16'
                        fill='currentColor'
                        className='bi bi-arrow-clockwise'
                        viewBox='0 0 16 16'
                      >
                        <path
                          fillRule='evenodd'
                          d='M8 3a5 5 0 1 0 4.546 2.914.5.5 0 0 1 .908-.417A6 6 0 1 1 8 2v1z'
                        />
                        <path d='M8 4.466V.534a.25.25 0 0 1 .41-.192l2.36 1.966c.12.1.12.284 0 .384L8.41 4.658A.25.25 0 0 1 8 4.466z' />
                      </svg>
                    </Button>
                  </Col>
                </Row>
                <div className='tabla-personalizada'>
                  <BootstrapTable
                    {...props.baseProps}
                    headerWrapperClasses='table-secondary'
                    pagination={paginationFactory(paginationOptions)}
                    noDataIndication={
                      <div className='text-center'>
                        No hay registros encontrados
                      </div>
                    }
                  />
                </div>
              </div>
            )}
          </ToolkitProvider>
        </Card>
      </Container>
    </Fragment>
  )
}

export default DetalleCasos
